(function ($, window) {
    'use strict';
    $(document).ready(
        function () {
            init();

            function init() {
                filter_handler();
                set_sortable();
                reset_filters();
                clear_params();
                apply_filters();
                set_price_filter();
                set_sidebar();
                close_active_filter();
                remove_filter_storage();
                set_filters();
                if (window.is_elementor_template()) {
                    set_elementor_filter_mode();
                }
                set_custom_select();
            }

            function get_shop_page_id() {
                const urlParams = new URLSearchParams(window.location.search);
                return urlParams.get('page_id');
            }


            function set_number_of_columns_by_screen_resolution() {
                $('.prodigy-product-list__grid').removeClass('d-none');
                let windowWidth = screen.width;
                let default_number_of_columns = settings.customizer_product_columns;
                let number_of_columns = 1;

                if (windowWidth >= 1440) {
                    number_of_columns = default_number_of_columns;
                } else if (windowWidth >= 1024) {
                    number_of_columns = (default_number_of_columns >= 4) ? 4 : default_number_of_columns;
                } else if (windowWidth >= 768) {
                    number_of_columns = (default_number_of_columns >= 3) ? 3 : default_number_of_columns;
                } else if (windowWidth >= 375) {
                    number_of_columns = (default_number_of_columns >= 2) ? 2 : default_number_of_columns;
                }

                $('.shop-resolution-js').addClass('prodigy-product-list__grid-' + number_of_columns);
            }

            function is_show_active_filter() {
                return $('.elementor-show-active-filter-js').val();
            }

            function set_elementor_filter_mode() {
                $('.prodigy-filter__sm-btn-js').click(function () {
                    $('.prodigy-filter-js').show();
                    $('.prodigy-filter__accordion-header-js').show();
                    $('.prodigy-shop-sidebar').toggleClass('prodigy-shop-sidebar--open');
                });
            }

            function set_filters() {
                $('.attribute-filter-js').each(function () {
                    if ($(this).is(':checked')) {
                        let attribute_name = $(this).data('attribute-id');
                        let attribute_value = $(this).data('attribute-value');
                        load_filters(attribute_name, attribute_value);
                    }
                });
            }

            function remove_filter_storage() {
                sessionStorage.removeItem('filter');
            }

            function close_active_filter() {
                $(document).on('click', '.filter-close-js', function () {
                    let element = $(this).closest('.prodigy-main-badge');
                    let attribute_id = element.data("attribute-id");
                    let attribute_value = element.data('attribute-slug');
                    unset_filter(attribute_id, attribute_value);
                    get_catalog_filters(build_query(), $(this));
                    get_catalog_products(build_query());
                });
            }

            function set_sidebar() {
                const filterToggleBtnHandler = () => {
                    $('#filter-toggle-btn').toggleClass('prodigy-shop-sidebar-btn--show');
                    $('#filter').toggleClass('prodigy-shop-sidebar--open');
                }
                $('body').on('click', '#filter-toggle-btn, #filter-toggle-btn-2, #shop-sidebar-backdrop-js', filterToggleBtnHandler);
            }

            function set_loader() {
                $('.prodigy-product-list__grid').addClass('prodigy__is-loading');
                $('.prodigy-loader-wrapper').show();
                $('.prodigy-loader-wrapper').attr("style", "display:flex");
                $('.prodigy-loader-wrapper').find('*').addClass('pointer-events-none');
            }

            function remove_loader() {
                $('.prodigy-product-list__grid').removeClass('prodigy__is-loading');
                $('.prodigy-loader-wrapper').hide();
                $('.prodigy-loader-wrapper').find('*').removeClass('pointer-events-none');
            }

            function set_price_filter() {
                $(document).on('click', '.price-filter-submit-js', function (e) {
                    let price_max = prodigyGetUrlParam('price_max');
                    let price_min = prodigyGetUrlParam('price_min');
                    let price_query = '';
                    if (price_min && price_min) {
                        price_query = 'price_max=' + price_max + '&price_min=' + price_min;
                    }
                    sessionStorage.setItem('price-range', price_query);
                    get_catalog_filters(build_query(), $(this).closest('.elementor-widget-pae-attributes'));
                    get_catalog_products(build_query());
                });
            }

            function apply_filters() {
                $(document).on('click', '.attribute-filter-js', function (e) {
                    let attribute_id = $(this).data('attribute-id');
                    let attribute_value = $(this).data('attribute-value');
                    if ($(this).is(':checked')) {
                        set_filters();
                    } else {
                        unset_filter(attribute_id, attribute_value);
                    }
                    get_catalog_filters(build_query(), $(this));
                    get_catalog_products(build_query());
                });
            }

            function clear_params() {
                $(document).on(
                    'click',
                    '.clear-params-js',
                    function (e) {
                        sessionStorage.removeItem('price-range');
                        sessionStorage.removeItem('catalog-sortable');
                        clear_url_params();
                        set_loader();
                    }
                );

                if (window.location.search === '') {
                    sessionStorage.removeItem('price-range');
                    sessionStorage.removeItem('catalog-sortable');
                }

                remove_loader();
            }

            function reset_filters() {
                $(document).on(
                    'click',
                    '.filter-reset-js',
                    function () {
                        clear_url_params();
                    }
                );
            }

            function clear_url_params() {
                remove_filter_storage();
                if (get_shop_page_id() !== null) {
                    window.location.href = window.location.origin + '?page_id=' + get_shop_page_id();
                } else {
                    window.location.href = window.location.href.split("?")[0];
                }
            }

            function build_query() {
                const filter = JSON.parse(sessionStorage.getItem('filter')) || {};
                const filter_query = jQuery.param(filter);
                let price_query = sessionStorage.getItem('price-range') || '';
                let total_query = filter_query ? `${filter_query}${price_query ? '&' + price_query : ''}` : price_query;

                const shop_page_id = get_shop_page_id();
                if (shop_page_id) {
                    total_query = `page_id=${shop_page_id}&${total_query}`;
                }

                if (total_query) {
                    history.pushState('', '', `?${total_query}`);
                } else {
                    history.pushState(null, null, window.location.pathname);
                }

                const category_name = $('.category-name-js').val();
                const category_slug = $('.slug-name-js').val();
                const current_url = window.location.href;

                if (category_name && category_slug) {
                    total_query += `&tax_name=${category_name}&tax_slug=${category_slug}`;
                }

                total_query += `&current_url=${current_url}`;

                return total_query;
            }


            function get_catalog_products(query) {
                let filter_widget_id = $('.filter-widget-id').val();
                let products_widget_id = $('.products-widget-id').val();
                let category = $('.prodigy-category-slug-js').val();
                let category_type = $('.prodigy-category-type-js').val();
                $('.prodigy-product-list__grid').addClass('prodigy__is-loading');
                set_loader();
                let ajax_url = ajaxurl + '?action=prodigy-load-shop-products&' + query + '&tax_slug=' + category + '&tax_name=' + category_type;
                if (typeof filter_widget_id !== "undefined") {
                    ajax_url = setUrlParameter(ajax_url, 'filter_widget_id', filter_widget_id);
                }
                if (typeof products_widget_id !== "undefined") {
                    ajax_url = setUrlParameter(ajax_url, 'products_widget_id', products_widget_id);
                }

                $.ajax({
                    type: "GET",
                    url: ajax_url,
                    cache: false,
                    dataType: "json",
                    success: function (response) {
                        remove_loader();
                        if (response.data && typeof response.data.pagination !== "undefined") {
                            $('.prodigy-pagination-shop-js').html(response.data.pagination);
                        }

                        if (response.data && typeof response.data.products !== "undefined") {
                            let empty_products = $(response.data.products).find('.shop-page-container-empty-js');
                            if (empty_products.length > 0 || !window.is_elementor_template()) {
                                let products = $(response.data.products).find('.shop-page-container-js');
                                $('.shop-page-container-js').replaceWith(products);
                            } else {
                                let products = $(response.data.products).find('.prodigy-product-list__grid');
                                let no_results = $(document).find('.shop-page-container-empty-js');

                                let container = '.prodigy-product-list__grid';
                                if (no_results.length > 0) {
                                    container = '.shop-page-container-empty-js';
                                }

                                $(container).replaceWith(products);
                            }
                        }
                        set_number_of_columns_by_screen_resolution();
                    }
                });
            }

            function get_catalog_filters(query, context) {
                let filter_widget_id = $('.filter-widget-id').val();
                let products_widget_id = $('.products-widget-id').val();
                let category = $('.prodigy-category-slug-js').val();
                let category_type = $('.prodigy-category-type-js').val();
                set_loader();
                let query_url = ajaxurl + '?action=prodigy-load-shop-filters&' + query + '&tax_slug=' + category + '&tax_name=' + category_type;
                if (typeof filter_widget_id !== "undefined") {
                    query_url = setUrlParameter(query_url, 'filter_widget_id', filter_widget_id);
                }
                if (typeof products_widget_id !== "undefined") {
                    query_url = setUrlParameter(query_url, 'products_widget_id', products_widget_id);
                }

                $.ajax({
                    type: "GET",
                    url: query_url,
                    cache: false,
                    dataType: "json",
                    success: function (response) {
                        if (typeof response.data !== "undefined") {
                            $('.catalog-sort-js').html($(response.data.sort).html());
                            let empty_products = $(response.data.products).find('.shop-page-container-empty-js');

                            if (empty_products.length > 0 || !window.is_elementor_template()) {
                                if ($('.prodigy-filter__badges').length > 0) {
                                    $('.prodigy-filter__badges').closest('.prodigy-filter__main').remove();
                                    $('.prodigy-filter__badges').remove();
                                }

                                $('.prodigy-filter__main').first().before(response.data.active);
                                $('.prodigy-filter-title-js').html(response.data.filters);
                            } else {
                                let filters = $(response.data.filters).closest('.prodigy-filter-js');
                                $('.prodigy-filter-js').replaceWith(filters);
                                if (is_show_active_filter()) {
                                    if ($('.active-filter-js').length > 0) {
                                        $('.active-filter-js').html(response.data.active);
                                    } else {
                                        if ($('.prodigy-filter__sm-btn-js').is(':visible')) {
                                            $('.prodigy-filter-by-title-js').eq(0).before(response.data.active);
                                        } else {
                                            $('.prodigy-filter-by-title-js').eq(0).before(response.data.active);
                                        }
                                    }
                                    $('.price-filter-container-js').html(response.data.price_filter);
                                    let price_filter = $(response.data.price_filter).find('.js-range-slider');
                                    $(document).find('.min-js').val($(price_filter).attr('data-min'));
                                    $(document).find('.max-js').val($(price_filter).attr('data-max'));
                                }

                                if ($('.prodigy-main-badge__val').length === 0) {
                                    $('.active-filter-js').remove();
                                }
                            }

                            let price_filter_container = $('.price-filter-container-js');
                            if (price_filter_container.length !== 0) {
                                price_filter_container.html(response.data.price);
                                window.slider_widget.init(
                                    response.data.min_price,
                                    response.data.max_price,
                                    response.data.query_min_price,
                                    response.data.query_max_price
                                );
                            }
                            set_custom_select();
                        }
                    }
                });
            }

            function set_custom_select() {
                $(document).find('.prodigy-custom-select').styler({
                    onFormStyled: function () {
                        $(document).find('.jq-selectbox__select-text').each(function () {
                            const width = $(this)
                                .closest('.jq-selectbox')
                                .find('select')
                                .width();
                        });
                    }
                });
            }

            function set_sortable() {
                $(document).on('click', '.catalog-page-sort-js', function () {
                        if ((navigator.platform.indexOf("iPhone") !== -1) || (navigator.platform.indexOf("iPod") !== -1)) {
                            $("select.catalog-page-sort-js").remove();
                        }
                        $('.catalog-page-device-sort-js').addClass('prodigy-select-md--open');
                    }
                );

                $(document).on('change', '.catalog-page-sort-js', function () {
                        let sort = $(this).children("option:selected").val();
                        if (typeof sort !== 'undefined') {
                            sessionStorage.setItem('catalog-sortable', sort.replace(/\?/g, '&'));
                            let newParams = [
                                ['sort', sort],
                            ];
                            let newUrl = document.location.pathname + prodigyInsertUrlParams(newParams);
                            history.pushState('', '', newUrl);
                            document.location.reload();
                        }
                    }
                );

                $(document).on(
                    'change',
                    '.sort-radio-js',
                    function () {
                        $('.sort-radio-js').each(function () {
                            if ($(this).is(':checked')) {
                                let sort = $(this).val();
                                if (typeof sort !== undefined) {
                                    sessionStorage.setItem('catalog-sortable', sort.replace(/\?/g, '&'));
                                    let newParams = [
                                        ['sort', sort],
                                    ];
                                    let newUrl = document.location.pathname + prodigyInsertUrlParams(newParams);
                                    history.pushState('', '', newUrl);
                                    document.location.reload();
                                }
                            }
                        });
                    }
                );

                $('body, .catalog-page-device-sort-close-js').click(function () {
                    $('.catalog-page-device-sort-js').removeClass('prodigy-select-md--open');
                });

                $('.prodigy-select-md__wrap').click(function (event) {
                    event.stopPropagation();
                });
            }

            function unset_filter(id, attribute) {
                let filter = sessionStorage.getItem('filter');
                let params = JSON.parse(filter);
                if (params === null) {
                    sessionStorage.removeItem('filter');
                } else {
                    let values = '';
                    if (typeof params['attr'] !== 'undefined' && typeof params['attr'][id] !== 'undefined') {
                        values = params['attr'][id].split(';');
                        values.forEach(function (value, key) {
                            if (attribute == value) {
                                values.splice(key, 1);
                            }
                        });
                    }
                    if (values.length > 0) {
                        let values_str = values.join(';');
                        params['attr'][id] = values_str;
                    } else {
                        delete params['attr'][id];
                    }
                    sessionStorage.setItem('filter', JSON.stringify(params));
                }

                if (id === 'Price') {
                    sessionStorage.removeItem('price-range')
                }

                uncheck_filter_checkbox(id, attribute);
            }

            function uncheck_filter_checkbox(id, attribute) {
                $('.attribute-filter-js').each(function () {
                    if ($(this).data('attribute-id') == id && $(this).data('attribute-name') == attribute) {
                        $(this).removeAttr('checked');
                    }
                })
            }

            function load_filters(id, value) {
                let sort = findGetParameter('sort');
                let filter = sessionStorage.getItem('filter');
                let params = JSON.parse(filter);

                if (params !== null && Object.keys(params['attr']).length !== 0) {
                    $.each(params['attr'], function (i, item) {
                        let parts = item.split(";");
                        if (i == id && parts.indexOf(value.toString()) === -1) {
                            params['attr'][id] = item + ';' + value.toString();
                        }
                    });
                }

                if (params === null || Object.keys(params['attr']).length === 0) {
                    params = {};
                    params['attr'] = {};
                    params['attr'][id] = value.toString();
                } else if (typeof params['attr'][id] === "undefined") {
                    params['attr'][id] = value.toString();
                }
                if (typeof sort !== "undefined" && sort !== null) {
                    params['sort'] = sort;
                }

                sessionStorage.setItem('filter', JSON.stringify(params));
            }

            function filter_handler() {
                // show more/less filter values
                $(document).on(
                    'click',
                    '.filter__btn-js',
                    function () {
                        const id_attr = $(this).data('id')
                        const list = $('.filter__item-list-js#filter_attr_' + id_attr)
                        const listItems = list.find('.prodigy-filter__item-list-li, .prodigy-filter__card-list-item')
                        const btnText = $(this).find('.filter__btn-txt-js')
                        const listOpenClass = 'active'
                        const moreText = 'Show more'
                        const lessText = 'Show less'
                        const countShow = list.data('count-show')

                        $(this).toggleClass(listOpenClass)

                        if ($(this).hasClass(listOpenClass)) {
                            btnText.text(lessText)
                            listItems.show()
                        } else {
                            btnText.text(moreText)
                            listItems.each(
                                function (i) {
                                    if (i + 1 > countShow) {
                                        $(this).hide()
                                    }
                                }
                            )
                        }
                    }
                );
            }
        }
    );
})(jQuery, window);
